import { BlurView, BlurViewProps } from 'expo-blur';
import React from 'react';
import { Platform, StyleSheet, View, ViewStyle } from 'react-native';

export interface CrossPlatformBlurViewProps extends BlurViewProps {
  style?: ViewStyle;
  fallbackColor?: string;
  children?: React.ReactNode;
}

const CrossPlatformBlurView: React.FC<CrossPlatformBlurViewProps> = ({
  intensity = 5,
  style = {},
  fallbackColor,
  children,
  ...props
}) => {
  // Calculate a reasonable opacity based on intensity for Android
  const androidOpacity = Math.min((intensity / 100) * 0.9, 0.9);

  // Determine the appropriate fallback color with opacity
  const defaultFallbackColor = `rgba(255,255,255,${androidOpacity})`;
  const backgroundColor = fallbackColor || defaultFallbackColor;

  if (Platform.OS === 'ios') {
    return (
      <BlurView
        intensity={intensity}
        style={[styles.container, style]}
        {...props}
      >
        {children}
      </BlurView>
    );
  } else {
    // For Android, use a semi-transparent View as fallback
    return (
      <View style={[styles.container, { backgroundColor }, style]} {...props}>
        {children}
      </View>
    );
  }
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
  },
});

export default CrossPlatformBlurView;
